export default __webpack_public_path__ + "51632ba0f251906925bb113f84685ba7.svg";